export default __webpack_public_path__ + "static/media/marcis-lakstigala-vegshelf.53cb32f4.png";